import classNames from 'classnames';

import type { PersonalizedSkeletonProps } from '../personalizedSkeletonTypes';
import classes from './RichTextPersonalizedSkeleton.module.scss';
import shared from './personalizedSkeletonShared.module.scss';

/** Fixed layout — do not derive slots from blok (Storyblok/hydration data is unstable during loading). */
const RichTextPersonalizedSkeleton: React.FC<PersonalizedSkeletonProps> = ({ blok }) => {
  if (blok.component !== 'component_rich_text') {
    return null;
  }

  return (
    <div className={classes.root} data-testid="personalized-content-skeleton-richtext">
      <div className={classNames(shared.shimmer, shared.headlineBar)} />

      <div className={shared.paragraphLines}>
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className={classNames(shared.shimmer, shared.lineBar, index % 3 === 2 && shared.lineBarShort)}
          />
        ))}
      </div>
    </div>
  );
};

export default RichTextPersonalizedSkeleton;
